import { type CountryType } from '@heidi/utils/countries';

/**
 * Enterprise (AZ1) country variants.
 *
 * These are intentionally NOT part of `countries.ts` (the source of truth for
 * every user-facing CountrySelect dropdown), so they never appear in normal
 * onboarding, signup, or settings flows. They are opt-in via the
 * `extraCountries` prop on CountrySelect — currently only the join-team flow
 * (`pages/new-team-user/OnboardingForm.tsx`) opts in, so users joining a team
 * provisioned on an enterprise stack can pick the matching enterprise country.
 *
 * Display `name` mirrors the backend `Country` enum value (e.g.
 * `Country.UNITED_ARAB_EMIRATES_AZ1 = "United Arab Emirates (Enterprise)"`)
 * so it round-trips cleanly when persisted on the user. The matching entries
 * in `countriesToRegion.ts` map these strings to their `*_AZ1` region for the
 * region-mismatch check.
 *
 * `countryCode` is shared with the non-enterprise variant so the country flag
 * still renders. `internationalCode` / `mobileLength` are intentionally
 * omitted — these aren't used for phone-number entry.
 */
export const enterpriseCountries: CountryType[] = [
  {
    countryCode: 'AU',
    name: 'Australia (Enterprise)',
  },
  {
    countryCode: 'JP',
    name: 'Japan (Enterprise)',
  },
  {
    countryCode: 'QA',
    name: 'Qatar (Enterprise)',
  },
  {
    countryCode: 'AE',
    name: 'United Arab Emirates (Enterprise)',
  },
  {
    countryCode: 'US',
    name: 'United States (Enterprise)',
  },
  {
    countryCode: 'SE',
    name: 'Sweden (Enterprise)',
  },
];
